import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Shimmer from '../../../../../components/Custom/Loading/Shimmer';
import {
  faEdit
} from "@fortawesome/free-solid-svg-icons";
const StepFive = ({ locations, taskDetails, setTaskDetails, handleSubmit, isSubmitting, currentStep, handlePreviousStep, loading }) => {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setTaskDetails(name, value);
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="card shadow mb-4"
        >
            <div className="card-body text-center">
                <h4 className="text-center">You are almost done.</h4>
                {loading ? <Shimmer type="list" /> : (
                    <>
                        <div className="form-group mb-4">
                            <label className="text-center">Please choose the campus</label>
                            <select
                                className="form-control"
                                name="locationID"
                                value={taskDetails.locationID || ''}
                                onChange={handleChange}
                                disabled={currentStep !== 5}
                            >
                                <option value="">Please choose a location</option>
                                {locations.map(location => (
                                    <option key={location.locationID} value={location.locationID}>
                                        {location.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group mb-4">
                            <label className="text-center">Enter some details so that the assignee can fully understand the requirement</label>
                            <textarea
                                className="form-control"
                                name="description"
                                rows={10}
                                value={taskDetails.description || ''}
                                onChange={handleChange}
                                disabled={currentStep !== 5}
                            ></textarea>
                        </div>
                    </>
                )}
                <button className="btn btn-secondary mt-3 btn-sm" onClick={handlePreviousStep}> <FontAwesomeIcon icon={faEdit} /> Edit</button>
                <button
                    className="btn btn-primary mt-3"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                >
                    {isSubmitting ? (
                        <span>
                            <i className="fas fa-spinner fa-spin"></i> Creating new task...
                        </span>
                    ) : (
                        <span>
                            <i className="fas fa-save"></i> Save
                        </span>
                    )}
                </button>
            </div>
        </motion.div>
    );
};

export default StepFive;
